<template>
    <section class="mb-64">

        <figure v-if="style === 'full-width'">

            <img class="w-full" :src="image.image_url" alt="">

            <div class="site__container">

                <figcaption
                    v-if="caption && caption.length"
                    :class="[ captionWidth ]" class="pt-24 pl-24 italic">
                    {{ caption }}
                </figcaption>

            </div>

        </figure>

        <div v-else class="site__container">

            <figure class="mx-auto flex flex-col items-center">

                <img class="block h-auto w-auto max-h-630 max-w-full site__rounded--medium" :src="image.image_url + '&w=920&fit=max'" alt="">

                <figcaption
                    v-if="caption && caption.length"
                    :class="[ captionWidth ]"
                    class="text-center pt-24 px-12 italic">
                    {{ caption }}
                </figcaption>
            </figure>
        </div>
    </section>
</template>

<script>
import { mapState } from 'pinia';
import { useBrandingStore } from '../../state/branding'
import { responsive } from '../../helpers';

export default {
    props: {
        image: {
            required: true,
        },
        caption: {
            default: '',
        }
    },
    data: function () {
        return {
            style: 'contain', // full-width/contain (has a max height of 720px)
        }
    },
    computed: {
        ...mapState(useBrandingStore, ['preview']),
        captionWidth () {
            return responsive(this.preview.type, 'w-full md:w-1/2 lg:w-1/3');
        }
    }
}
</script>

<style scoped>

</style>
